import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import request from '../../utils/request';
const { Paragraph } = Typography;


const DownloadApp = () => {
  const [isApp, setIsApp] = useState(false)


  // 游戏下载url
  const downloadUrlApi = async () => {
    let res = await request.get('/web/gameFile/getGameUrl')
    if (res.code !== 200) return
    const downloadUrl = res.data;  //其他版本包
    // const downloadUrl = 'https://saclient.giraffar.com/Download/GiraffeStoneAge_1.9.1.0_541918082023.apk';  //其他版本包
    // const downloadUrl = 'https://sa.giraffar.com/folder/stoneage_1.0.exe';  //雷电模拟器包
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();

    return () => {
      document.body.removeChild(link);
    };

  }

  // 雷电包
  const downloadLeiDianUrlApi = async () => {
    let res = await request.get('/web/gameFile/getSimulatorUrl')
    if (res.code !== 200) return
    const downloadUrl = res.data;  //雷电
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();

    return () => {
      document.body.removeChild(link);
    };

  }


  useEffect(() => {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
      window.open('https://apps.apple.com/cn/app/id6446824119', '_self')
    }
    if (!isiOS) {
      // 抖音，微信，QQ浏览器
      if (/aweme/.test(u) || /MicroMessenger/.test(u) || /QQTheme/.test(u)) {
        return setIsApp(true)
      }
      // downloadUrlApi()  //游戏url
      downloadLeiDianUrlApi()  //雷电url
    }

  }, []);

  useEffect(() => {

  }, []);

  return <>
    {isApp &&
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '40px', overflow: 'hidden', height: '70vh', color: '#000' }}>
        <p style={{ textAlign: 'center' }}>请您前往浏览器，打开以下地址，完成游戏下载</p>

        <div style={{
          width: '85vw',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          {/* <Paragraph copyable>http://sa.giraffar.com/download_link/xsqsdnc/android_default/</Paragraph> */}
          <Paragraph copyable>http://sa.giraffar.com/folder</Paragraph>
        </div>
      </div>
    }

  </>;
};

export default DownloadApp;
